import { colors } from '@lmc/common/constants'
import type { SvgType } from './types'

export default function CheckboxOff({ fill, style, size, viewBox }: SvgType) {
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      style={style}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x={3.5}
        y={3.5}
        width={17}
        height={17}
        rx={1.5}
        stroke={colors.darkgrey}
        fill="none"
      />
    </svg>
  )
}
